import app from "../_app";
import {addToCartHandler} from "./addToCart";
import {openProductPopupHandler} from "./productPopup";
import {openOutofstockHandler} from "./productOutofstock";
import {recentProducts} from "./recently-viewed";
import {closerelatedPopupHandler} from "./productRelated";
import axios from "axios";
import {toggleMicrocart} from "./microcart";

const product = document.querySelector('.js-product');
const relatedProducts = [...document.querySelectorAll('.js-product-related')];
const deliveryTime = document.querySelector('.js-delivery-time');
const judgemeReviews = document.querySelector('.js-judgeme');
const reviewsAccordion = document.querySelector('.js-reviews-accordion');

const upsellsChangeHandler = () => {

    const relatedVariantsProducts = [...product.querySelectorAll('.js-product-related-variant')];
    const upsells = product.querySelectorAll('.js-upsells');
    const upsellProducts = [...upsells[0].querySelectorAll('.js-upsell')];
    upsells[0].classList.add('active');

    relatedProducts.map((relatedProduct) => {
        if(relatedProduct.checked){

            upsellProducts.map((upsellProduct) => {
                if(upsellProduct.dataset.id === relatedProduct.dataset.id){
                    upsellProduct.classList.remove('d-none');
                    upsellProduct.classList.add('d-flex');
                    upsells[0].scrollIntoView({block: 'start', behavior: 'smooth'});
                }
            });
        }else{

            upsellProducts.map((upsellProduct) => {
                if(upsellProduct.dataset.id === relatedProduct.dataset.id){
                    upsellProduct.classList.remove('d-flex');
                    upsellProduct.classList.add('d-none');
                }
            });
        }
    });

    relatedVariantsProducts.map((relatedProduct) => {
        if(relatedProduct.checked){
            upsellProducts.map((upsellProduct) => {

                if(upsellProduct.dataset.id === relatedProduct.dataset.id){
                    upsellProduct.classList.remove('d-none');
                    upsellProduct.classList.add('d-flex');
                    upsellProduct.querySelector('.js-upsell-size').innerHTML = ' (' + relatedProduct.dataset.label + ')';
                    upsells[0].scrollIntoView({block: 'start', behavior: 'smooth'});
                }
            });
        }
    });
};

function hasParentWithClass(element, className) {
    while (element) {
        if (element.classList && element.classList.contains(className)) {
            return true;
        }
        element = element.parentNode;
    }
    return false;
}

export const initVariantsButtons = (type) => {

    const variantsButtons = [...document.querySelectorAll('.js-product-variant-button')];
    variantsButtons.map((variant, index) => {
        let fired = false;

        if (hasParentWithClass(variant, 'js-related-popup-content-directadd') || type === 'direct') {
            variant.addEventListener('click', () => {
                if (variant.dataset.outofstock !== undefined) {
                    openOutofstockHandler(variant);
                } else {
                    const formData = {
                        items: [{
                            id: variant.dataset.variantid,
                            quantity: 1
                        }]
                    };
                    async function submitVariant() {
                        try {
                            await axios.post('/cart/add.js', formData);
                            closerelatedPopupHandler();
                            // direct = microcart, else normal cart

                            if(type !== 'direct') {
                                location.reload(true);
                            }else {
                                toggleMicrocart(true);
                            }

                        } catch (e) {
                            console.log(e.response.data);
                        }
                    }
                    submitVariant();
                }
            });

        }else {
            variant.addEventListener('click', () => {

                if (variant.dataset.outofstock !== undefined) {
                    openOutofstockHandler(variant);
                }

                if (variant.classList.contains('js-related-variant')) {
                    if (!fired) {
                        const form = document.querySelector('.js-product-form');
                        let currentValue = form.getAttribute('data-dynamic-variant');
                        if (currentValue) {
                            form.setAttribute('data-dynamic-variant', currentValue + ',' + variant.dataset.variantid);
                        } else {
                            form.setAttribute('data-dynamic-variant', variant.dataset.variantid);
                        }

                    }
                    fired = true;

                    closerelatedPopupHandler();
                    upsellsChangeHandler();
                }
            });
        }
    });
}

const showHideAddToCartFixed = () => {
    const productAddToCartOriginal = product.querySelector('.js-product-add-to-cart-original');
    const productAddToCartFixed = product.querySelector('.js-product-add-to-cart-fixed');
    const usps = document.querySelector('.usps');
    
    if(document.body.classList.contains('locked') || !productAddToCartFixed) {
        return;
    }

    const isAtUsps = productAddToCartFixed.getBoundingClientRect().bottom >= usps.getBoundingClientRect().top;

    if (productAddToCartOriginal.getBoundingClientRect().bottom < 0 && !isAtUsps) {
        productAddToCartFixed.classList.remove('hide');
    } else {
        productAddToCartFixed.classList.add('hide');
    }
}

export const showHideDeliveryTime = (selectedVariantQuantity) => {
  const deliveryTimeTreshold = deliveryTime?.querySelector('.delivery-time__treshold');
  const deliveryTimeInStock = deliveryTime?.querySelector('.delivery-time__in-stock');

  // The delivery time falls back to a static message when stock isn't tracked, which leaves
  // nothing to toggle.
  if (!deliveryTimeTreshold || !deliveryTimeInStock) {
      return;
  }

  const quantityTreshold = parseInt(deliveryTime.dataset?.quantityTreshold);
  const selectedVariantQuantityNumber = parseInt(selectedVariantQuantity);

  const toggleClasses = (element, addClass, removeClass) => {
      element.classList.add(addClass);
      element.classList.remove(removeClass);
  };

  if (selectedVariantQuantityNumber > 0 && selectedVariantQuantityNumber <= quantityTreshold) {
      toggleClasses(deliveryTimeTreshold, 'd-block', 'd-none');
      toggleClasses(deliveryTimeInStock, 'd-none', 'd-block');
      deliveryTimeTreshold.querySelector('span').textContent = selectedVariantQuantity;
  } else {
      toggleClasses(deliveryTimeTreshold, 'd-none', 'd-block');
      toggleClasses(deliveryTimeInStock, 'd-block', 'd-none');
  }
}

const replaceVariantImage = (selectedVariantId, variantImageElements, variantImageData) => {
  const newImageSrcset = variantImageData[selectedVariantId];

  variantImageElements.forEach((imageElement) => {
    const sourceElements = imageElement.querySelectorAll('source');
    const image = imageElement.querySelector('img');

    sourceElements.forEach(function(sourceElement) {
        sourceElement.remove();
    });
    
    image.srcset = newImageSrcset
  });
}

if(product) {
    const form = product.querySelector('.js-product-form');
    const price = product.querySelectorAll('.js-product-price');
    const compareAtPrice = product.querySelector('.js-product-compare-at-price');
    const variantsCheckboxes = [...product.querySelectorAll('.js-product-variant')];
    const variantOneSort = product.querySelector('.js-variants-one-sort');
    const variantSort = product.querySelector('.js-variants-sort');
    const variantLabel = document.querySelector('.js-variant-label');
    const variantImageElements = document.querySelectorAll('.js-variant-image');
    const variantImageDataElement = document.getElementById('product-variant-image-data');
    let variantImageData = {};

    if (variantImageDataElement) {
        try {
            variantImageData = JSON.parse(variantImageDataElement.textContent);
        } catch (error) {
            console.error('Unable to parse product variant image data', error);
        }
    }

    initVariantsButtons();

    const updatePreOrderMessage = (variantPreOrderMessage, productPreOrderMessage) => {
        const preOrderMessageContainer = product.querySelector('.js-pre-order-message');
        const deliveryTimeContainer = product.querySelector('.js-delivery-time');
        
        if (!preOrderMessageContainer) return;

        const preOrderMessageText = preOrderMessageContainer.querySelector('.js-pre-order-message-text');
        const message = variantPreOrderMessage || productPreOrderMessage || '';

        if (message) {
            if (preOrderMessageText) {
                preOrderMessageText.textContent = message;
            }
            preOrderMessageContainer.classList.remove('d-none');
            // Hide delivery time when pre-order message is active
            if (deliveryTimeContainer) {
                deliveryTimeContainer.classList.add('d-none');
            }
        } else {
            preOrderMessageContainer.classList.add('d-none');
            // Show delivery time when pre-order message is not active
            if (deliveryTimeContainer) {
                deliveryTimeContainer.classList.remove('d-none');
            }
        }
    };

    const updateUspList = (variantPreOrderMessage, productPreOrderMessage) => {
        const uspList = product.querySelector('.usp-list');
        if (!uspList) return;

        const message = variantPreOrderMessage || productPreOrderMessage || '';
        const preOrderUsp = uspList.querySelector('.js-pre-order-usp');
        const defaultUspButton = uspList.querySelector('.js-default-usp-button');
        
        if (preOrderUsp) {
            const uspText = preOrderUsp.querySelector('.delivery-time__in-stock');
            if (uspText) {
                if (message) {
                    uspText.textContent = message;
                    preOrderUsp.classList.remove('d-none');
                    // Hide default button when pre-order message is active
                    if (defaultUspButton) {
                        defaultUspButton.classList.add('d-none');
                    }
                } else {
                    preOrderUsp.classList.add('d-none');
                    // Show default button when pre-order message is not active
                    if (defaultUspButton) {
                        defaultUspButton.classList.remove('d-none');
                    }
                }
            }
        }
    };

    const variantChangeHandler = ({currentTarget, replaceImage = true}) => {
        const {value: variantId, dataset} = currentTarget;
        
        price.forEach((priceElement) => {
            priceElement.setAttribute('data-price', dataset.price);
            priceElement.innerText = app.currency(dataset.price);
        })

        if(dataset.compareAtPrice) {
            compareAtPrice.setAttribute('data-price', dataset.compareAtPrice);
            compareAtPrice.innerText = app.currency(dataset.compareAtPrice);
            compareAtPrice.classList.remove('d-none');

        } else if(compareAtPrice) {
            compareAtPrice.classList.add('d-none');
        }

        if (deliveryTime && dataset.quantity) {
            showHideDeliveryTime(dataset.quantity);
        }

        if (replaceImage && variantImageElements.length > 0) {
            replaceVariantImage(variantId, variantImageElements, variantImageData);
        }

        if (dataset.label) {
            variantLabel.innerHTML = dataset.label;
        }

        const preOrderMessageContainer = product.querySelector('.js-pre-order-message');
        const productPreOrderMessage = preOrderMessageContainer ? preOrderMessageContainer.dataset.productPreOrderMessage || '' : '';
        const variantPreOrderMessage = currentTarget.getAttribute('data-pre-order-message') || '';
        
        updatePreOrderMessage(variantPreOrderMessage, productPreOrderMessage);
        updateUspList(variantPreOrderMessage, productPreOrderMessage);
    };

    if(form) {
        form.addEventListener('submit', addToCartHandler);
    }

    const saveOnSetButton = document.querySelector('.js-save-on-set-add');
    const saveOnSetPopup = document.querySelector('.js-save-on-set-popup');
    const saveOnSetBundle = saveOnSetPopup ? saveOnSetPopup.querySelector('.js-save-on-set-bundle') : null;

    const getSaveOnSetSelectedItems = (root) => JSON.stringify(
        [...root.querySelectorAll('.js-save-on-set-variant:checked')].map(variant => ({
            merchandiseId: `gid://shopify/ProductVariant/${variant.value}`,
            productId: `gid://shopify/Product/${variant.dataset.productId}`,
            productHandle: variant.dataset.productHandle,
            price: variant.dataset.price,
            quantity: '1',
        }))
    );

    const resetSaveOnSetPopup = () => {
        if (!saveOnSetBundle) {
            return;
        }

        [...saveOnSetBundle.querySelectorAll('[data-save-on-set-item] .js-save-on-set-variant')].forEach((variant) => {
            variant.checked = false;
        });
    };

    const closeSaveOnSetPopup = () => {
        if (!saveOnSetPopup) {
            return;
        }

        saveOnSetPopup.removeAttribute('data-open');
        resetSaveOnSetPopup();
        app.unlockBody();
    };

    const addSaveOnSetToCart = async (variantId, button, bundleSelectedItems) => {
        const productTitle = button.getAttribute('data-product-title');
        const item = {id: variantId, quantity: 1};

        if (bundleSelectedItems && bundleSelectedItems !== '[]') {
            item.properties = {_bundle_selected_items: bundleSelectedItems};
        }

        button.setAttribute('data-state', 'loading');
        button.disabled = true;

        try {
            const {status} = await axios.post(`${window.Shopify.routes.root}cart/add.js`, {
                items: [item]
            });

            if(status === 200) {
                button.setAttribute('data-state', 'done');

                if(button.hasAttribute('data-microcart')) {
                    await toggleMicrocart(true);

                    if(productTitle) {
                        const messageElement = document.querySelector('.js-microcart-product-added-message strong');

                        if(messageElement) {
                            messageElement.textContent = productTitle;
                        }
                    }
                }

                setTimeout(() => {
                    button.removeAttribute('data-state');
                    button.disabled = false;
                }, 1500);
            }
        } catch (error) {
            button.removeAttribute('data-state');
            button.disabled = false;
        }
    };

    if(saveOnSetButton) {
        saveOnSetButton.addEventListener('click', async (e) => {
            e.preventDefault();
            e.stopPropagation();

            if(saveOnSetButton.getAttribute('data-has-bundle-variants') === 'true' && saveOnSetPopup) {
                saveOnSetPopup.setAttribute('data-open', '');
                app.lockBody();
                return;
            }

            await addSaveOnSetToCart(
                saveOnSetButton.getAttribute('data-variant-id'),
                saveOnSetButton,
                saveOnSetButton.getAttribute('data-bundle-selected-items')
            );
        });
    }

    if (saveOnSetPopup && saveOnSetButton && saveOnSetBundle) {
        [...saveOnSetPopup.querySelectorAll('.js-save-on-set-popup-close')].forEach((trigger) => {
            trigger.addEventListener('click', closeSaveOnSetPopup);
        });

        [...saveOnSetBundle.querySelectorAll('[data-save-on-set-item] .js-save-on-set-variant')].forEach((variant) => {
            variant.addEventListener('change', async () => {
                const configurableItems = [...saveOnSetBundle.querySelectorAll('[data-save-on-set-item]')];
                const allSelected = configurableItems.every((item) => item.querySelector('.js-save-on-set-variant:checked'));

                if (!allSelected) {
                    return;
                }

                const bundleSelectedItems = getSaveOnSetSelectedItems(saveOnSetBundle);
                closeSaveOnSetPopup();
                await addSaveOnSetToCart(
                    saveOnSetButton.getAttribute('data-variant-id'),
                    saveOnSetButton,
                    bundleSelectedItems
                );
            });
        });
    }

    if(variantsCheckboxes.length > 0) {
        const selectedVariantHandler = () => {
            const selectedVariant = variantsCheckboxes.find(variant => variant.checked);

            if(selectedVariant) {
                variantChangeHandler({currentTarget: selectedVariant, replaceImage: false});
            }
        };

        setTimeout(selectedVariantHandler, 1);

        // On a back navigation the browser restores the selected variant, but the price comes from
        // the cached markup. pageshow fires after that restore, so the price catches up with the
        // selection.
        window.addEventListener('pageshow', selectedVariantHandler);
    }

    variantsCheckboxes.map(variant => variant.addEventListener('change', variantChangeHandler));

    if(relatedProducts) {

        relatedProducts.map((relatedProduct) => {
            relatedProduct.addEventListener('click', () => {
                upsellsChangeHandler();
            });

        });
    }

    window.addEventListener('scroll', showHideAddToCartFixed);

    recentProducts(product.dataset.handle);

    const imageSlider = document.querySelector('.js-image-slider');
    const track = imageSlider.querySelector('.js-slider-track');
    const navigation = imageSlider.querySelector('.js-slider-navigation');
    const navigationItems = [...navigation.querySelectorAll('.js-slider-navigation-item')];
    const totalNavigationItems = navigationItems.length;
    const breadcrumbText = document.querySelector('.js-breadcrumbs-text');

    if (track) {
        const MAX_VISIBLE_INDICATORS = 3;
        let min = 0;
        let max = MAX_VISIBLE_INDICATORS;
      
        const updateMinMax = (currentIndex, length) => {
            if (currentIndex < min) {
                min = currentIndex;
                max = min + MAX_VISIBLE_INDICATORS;
      
                if (max > length) {
                    max = length;
                }
            }
      
            if (currentIndex > max - 1) {
                max = currentIndex + 1;
                min = max - MAX_VISIBLE_INDICATORS;
      
                if (min < 0) {
                    min = 0;
                }
            }
        }
        
        const getIndicatorClass = (ref, currentIndex) => {
            if (ref === currentIndex) {
                return 'active';
            }
      
            if (ref >= min && ref < max) {
                return 'default';
            }
      
            if (ref === min - 1 || ref === max) {
                return 'small';
            }
      
            if (ref === min - 2 || ref === max + 1) {
                return 'micro';
            }
      
            return 'hidden';
        }

        track.addEventListener('scroll', event => {
            const currentIndex = Math.round(event.target.scrollLeft / event.target.offsetWidth);

            if (breadcrumbText) {
                breadcrumbText.classList.toggle('fadeout', currentIndex > 0);
            }

            updateMinMax(currentIndex, totalNavigationItems);

            navigationItems.forEach((navigationItem, index) => {
                const indicatorClass = getIndicatorClass(index, currentIndex);

                navigationItem.classList.remove('active', 'default', 'small', 'micro', 'hidden');
                navigationItem.classList.add(indicatorClass);
            });
        });
    }

    if(variantOneSort) {
        const variantsOne = [...variantOneSort.querySelectorAll('.js-variant-one-sort')];

        variantsOne.sort(function(a, b) {
            var titleA = a.getAttribute('data-title');
            var titleB = b.getAttribute('data-title');

            return titleA.localeCompare(titleB, undefined, { numeric: true, sensitivity: 'base' });
        });
        
        variantOneSort.innerHTML = '';

        variantsOne.forEach(function(variant) {
            variantOneSort.appendChild(variant);
            variant.classList.remove('d-none');
        });
    }

    if(variantSort) {
        const variants = [...variantSort.querySelectorAll('.js-variant-sort')];

        variants.sort(function(a, b) {
            var titleA = a.getAttribute('data-title');
            var titleB = b.getAttribute('data-title');

            return titleA.localeCompare(titleB, undefined, { numeric: true, sensitivity: 'base' });
        });

        variantSort.innerHTML = '';

        variants.forEach(function(variant) {
            variantSort.appendChild(variant);
            variant.classList.remove('d-none');
        });
    }
}

if (judgemeReviews) {
  const urlParams = new URLSearchParams(window.location.search);

  if (urlParams.get('judgeme_token')) {
      judgemeReviews.classList.remove('d-none');
  }
}

if (reviewsAccordion) {
    const urlParams = new URLSearchParams(window.location.search);

    if (urlParams.get('open-reviews')) {
        openProductPopupHandler(reviewsAccordion);
        urlParams.delete('open-reviews');
        const query = urlParams.toString();
        const cleanUrl = `${window.location.pathname}${query ? `?${query}` : ''}${window.location.hash}`;
        window.history.replaceState({}, '', cleanUrl);
    }

    const productReviewsBadge = document.querySelectorAll('.js-product-reviews-badge');

    [productReviewsBadge[0], reviewsAccordion].forEach((element) => {
        if (element) {
            element.addEventListener('click', () => {
                openProductPopupHandler(reviewsAccordion);
            });
        }
    });
}

export const initPopupTriggers = () => {
    const popupTriggers = [...document.querySelectorAll('.js-pdp-popup')];

    popupTriggers.map((popupTrigger) => {
        popupTrigger.addEventListener('click', () => {
            openProductPopupHandler(popupTrigger);
        });
    });
}

initPopupTriggers();
